<template>
  <div>
    <h4 class="subscribe__title">
      {{ title }}
    </h4>
    <input v-model="email" class="subscribe__input" type="email" name="email" :placeholder="inputPlaceholder" :disabled="inProgress">
    <button @click="fetchSubscriber()" class="subscribe__btn" type="submit" :disabled="inProgress">
      {{ btnSubmitText }}
    </button>

    <google-recaptcha-v3
        id="subscribe_action"
        ref="captcha"
        v-model="gRecaptchaResponse"
        :site-key="captcha_site_key"
        action="subscribe_action"
        corner
    />

    <div class="subscribe__text">
      {{ subscribeText }}
    </div>
  </div>
</template>

<script>
export default {
  name:  "Subscriber",
  props: {
    action:           {
      type: String
    },
    title:            {
      type: String
    },
    inputPlaceholder: {
      type: String
    },
    btnSubmitText:    {
      type: String
    },
    subscribeText:    {
      type: String
    },
    captcha_site_key: {
      type: String
    },
  },
  data() {
    return {
      email:              '',
      inProgress:         false,
      gRecaptchaResponse: null,
    }
  },
  methods: {
    fetchSubscriber() {

      if (this.inProgress) {
        return;
      }

      this.inProgress = true;

      const data = {
        'email':              this.email,
        'gRecaptchaResponse': this.gRecaptchaResponse
      };

      axios.post(this.action, data)
          .then((response) => {
            window.toastr.success(response.data.message);
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          })
          .finally(() => {
            this.email = '';
            this.inProgress = false;
            this.$refs.captcha.execute();
          });
    }
  }
}
</script>

